
import PropTypes from 'prop-types'
import React from 'react'
import Gravatar from './Gravatar'
import { Cross } from '@segment/icons/react'
import { color as colors } from 'ui/variables'
import './CollaboratorListItem.css'

const CollaboratorListItem = props => {
  const { name, email, canRemove, onRemove } = props
  return (
    <div className='CollaboratorListItem'>
      <div className='CollaboratorListItem-gravatar'>
        <Gravatar size={40} email={email} name={name} color='light' />
      </div>
      <div className='CollaboratorListItem-userInfo'>
        <div className='CollaboratorListItem-userName'>{name}</div>
        <div className='CollaboratorListItem-userEmail'>{email}</div>
      </div>
      <div className='CollaboratorListItem-removeAction' hidden={!canRemove} onClick={onRemove}>
        <Cross color={colors.grey[400]} />
      </div>
    </div>
  )
}

CollaboratorListItem.propTypes = {
  name: PropTypes.string.isRequired,
  email: PropTypes.string.isRequired,
  canRemove: PropTypes.bool.isRequired,
  onRemove: PropTypes.func.isRequired
}

CollaboratorListItem.displayName = 'CollaboratorListItem'

export default CollaboratorListItem



// WEBPACK FOOTER //
// ./ui/CollaboratorListItem.js